<template>
  <div class="w-full bg-white height-100 flex justify-center items-center">
    <div class="">
      <div>
        <div class="flex justify-center">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="w-100px"
          />
        </div>
        <div class="text-center mt-4">
          <h4 class="font-semibold text-4d4d4d text-3xl">
            All done! Time to review
          </h4>
          <p class="fsize14 col-4f mt-2">Please come after 24-48 hours.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VueEllipseProgress from "vue-ellipse-progress";

export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
